import LOGO from "../images/DublanCity.png";

export const Team__DublanCity = {
  name: "Dublan City",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#111111",
  teamJerseyColor: "#222222",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  // ownGoalsInFavor: 61 + 46 + 36,
  // goalsScoredAgainst: 49 + 45 + 47,
  ownGoalsInFavor: 46 + 36,
  goalsScoredAgainst: 45 + 47,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
